import React from 'react';

export const ProductsListItemLoading = () => {
    return (
        <li className="list-group-item">
            <div className="row">
                <div className="col-lg-1 col-xl-1">
                    <p className="text-center text-secondary mt-3 mt-md-0">
                        <svg
                            className="bd-placeholder-img"
                            width="32"
                            height="32"
                            xmlns="http://www.w3.org/2000/svg"
                            role="img"
                            aria-label="Placeholder"
                            preserveAspectRatio="xMidYMid slice"
                            focusable="false">
                            <title>Placeholder</title>
                            <rect width="100%" height="100%" fill="#C4C8CB"></rect>
                        </svg>
                    </p>
                </div>
                <div className="placeholder-glow col-lg-8 col-xl-9">
                    <span className="placeholder w-100 mt-1 mb-2"></span>
                </div>
                <div className="col-lg-3 col-xl-2">
                    <div className="d-grid">
                        <span className="btn btn-primary disabled placeholder mb-2"></span>
                    </div>
                </div>
            </div>
        </li>
    );
};
